import { render, staticRenderFns } from "./SaleTypeList.vue?vue&type=template&id=f6ff52a8&scoped=true"
import script from "./SaleTypeList.vue?vue&type=script&lang=ts"
export * from "./SaleTypeList.vue?vue&type=script&lang=ts"
import style0 from "./SaleTypeList.vue?vue&type=style&index=0&id=f6ff52a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff52a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ff52a8')) {
      api.createRecord('f6ff52a8', component.options)
    } else {
      api.reload('f6ff52a8', component.options)
    }
    module.hot.accept("./SaleTypeList.vue?vue&type=template&id=f6ff52a8&scoped=true", function () {
      api.rerender('f6ff52a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeList.vue"
export default component.exports